import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function for composing TailwindCSS class names.
 *
 * Why this exists:
 *  - `clsx` lets you conditionally combine class names.
 *      → Handles expressions like `isOpen && "bg-blue-500"`, arrays, and objects.
 *  - `tailwind-merge` intelligently resolves conflicting Tailwind utilities.
 *      → For example, `twMerge("p-2 p-6")` becomes `"p-6"`, keeping only the last padding class.
 *
 * By wrapping them together, `cls()` gives you:
 *  ✅ Conditional class logic (`clsx`)
 *  ✅ Automatic deduplication and conflict resolution (`twMerge`)
 *  ✅ Cleaner and more predictable Tailwind styling
 *
 * Usage example:
 *    <div className={cn(
 *      "bg-white p-4 rounded",
 *      isActive && "bg-blue-500",
 *      className
 *    )} />
 */
export function cls(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
